<template>
  <div
    class="product__product-text"
    v-if="typeof currentProduct !== 'undefined'"
    :class="{ 'product__product-text--loading': loading }"
    v-html="description">
    
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export default {
  name: 'ProductText',
  data: () => ({
    loading: true
  }),
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    description: {
      get () {
        return !this.loading ?
        documentToHtmlString(this.currentProduct.fields.description) :
        ''
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadProducts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./component.scss";
</style>
